module.exports = __webpack_public_path__ + "static/img/home_on.d1dd681f.png";